import { useSelector } from 'react-redux';

import { selectFilters } from 'shared/selectors';
import { EDealType, EOfferType } from 'shared/types/features';

export type TUseSobFiltersResult = {
  dealType: EDealType;
  offerType: EOfferType;
};

export const useSobFilters = (): TUseSobFiltersResult => {
  const { dealType, offerType } = useSelector(selectFilters);

  if (!dealType || !offerType) {
    throw new Error('SOB filters must be defined');
  }

  return { dealType, offerType };
};
